import {SlidersIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import type React from 'react'
import {useRef, useState} from 'react'

import {McpToolsManager} from './McpToolsManager'

export const McpToolMenu: React.FC = () => {
  const [toolsOpen, setToolsOpen] = useState(false)
  const toolsButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <Button
        ref={toolsButtonRef}
        leadingVisual={SlidersIcon}
        variant="invisible"
        aria-label="MCP Tools"
        onClick={() => setToolsOpen(true)}
      >
        Tools
      </Button>
      <McpToolsManager anchorRef={toolsButtonRef} open={toolsOpen} onOpenChange={setToolsOpen} />
    </>
  )
}

try{ McpToolMenu.displayName ||= 'McpToolMenu' } catch {}